(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/game-analyzes/map-analysis.js') >= 0) return;  svs.modules.push('/components/sport/game-analyzes/map-analysis.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
let isTipsetProduct;
let helpers;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  isTipsetProduct = trinidad.components.require('utils', 'products').isTipsetProduct;
  helpers = trinidad.components.require('utils', 'products').helpers;
} else {
  isTipsetProduct = svs.utils.products.isTipsetProduct;
  helpers = svs.utils.products.helpers;
}
function findTipsetSROWPrediction(predictions) {
  for (let i = 0; i < predictions.length; ++i) {
    if (predictions[i].system === 'SROW') {
      return predictions[i];
    }
  }
}
function findBombenMSYSPrediction(predictions) {
  for (let i = 0; i < predictions.length; ++i) {
    if (predictions[i].systemType === 'MSYS') {
      return predictions[i];
    }
  }
}

const mapAnalysis = analysis => {
  const toAppend = {};
  const isTipset = isTipsetProduct(analysis.gameinfo.products[0]);
  const isBomben = helpers.isBomben(analysis.gameinfo.products[0]);
  const isRacing = helpers.isRacing(analysis.gameinfo.products[0]);
  if (isTipset) {
    toAppend.awaySelected = false;
    toAppend.drawSelected = false;
    toAppend.homeSelected = false;
  } else if (isBomben) {
    toAppend.hasSelectionsForBothMatches = false;
  }
  if (analysis && analysis.properties && analysis.properties.cnt_gamePrediction && typeof analysis.properties.cnt_gamePrediction === 'string') {
    var _prediction;
    let prediction;
    try {
      prediction = JSON.parse(analysis.properties.cnt_gamePrediction);
    } catch (error) {
      throw new Error("Error when trying to parse prediction data: ".concat(error));
    }
    if ((_prediction = prediction) !== null && _prediction !== void 0 && _prediction.prediction) {
      toAppend.parsedPrediction = prediction;
      if (isRacing) {
        const currentParticipantIds = prediction.prediction.filter(item => item.participantId);
        const currentParticipantId = currentParticipantIds && currentParticipantIds.length > 0 ? currentParticipantIds[0].participantId : undefined;
        prediction.prediction.forEach(item => {
          item.participantId = currentParticipantId;
        });
      }
      if (prediction.prediction.length) {
        if (isTipset) {
          const srow = findTipsetSROWPrediction(prediction.prediction);
          if (srow) {
            const predictedOutcomes = srow.outcomes;
            if (Array.isArray(predictedOutcomes)) {
              const outcomes = [];
              predictedOutcomes.forEach(outcome => {
                if (outcome && outcome.outcomeNumber) {
                  outcomes.push(outcome.outcomeNumber);
                }
              });
              toAppend.homeSelected = outcomes.indexOf('1') > -1;
              toAppend.drawSelected = outcomes.indexOf('X') > -1;
              toAppend.awaySelected = outcomes.indexOf('2') > -1;
            }
          }
        } else if (isBomben) {
          const msys = findBombenMSYSPrediction(prediction.prediction);
          if (msys) {
            const hasSelectionsForBothMatches = Array.isArray(msys.boardData) && msys.boardData.length === 2 && msys.boardData[0].length > 0 && msys.boardData[1].length > 0;
            toAppend.hasSelectionsForBothMatches = hasSelectionsForBothMatches;
            if (hasSelectionsForBothMatches) {
              toAppend.home = msys.boardData[0][0];
              toAppend.away = msys.boardData[1][0];
            }
          }
        }
      }
      return _objectSpread(_objectSpread({}, analysis), toAppend);
    }
  }
};
if (svs.isServer) {
  module.exports = mapAnalysis;
} else {
  setGlobal('svs.sport.gameAnalyzes.mapAnalysis', mapAnalysis);
}
 })(window);